import { API_BASE_URL } from "../config";
import { downloadReportResponse } from "./reportsServices";

export const REPORT_EXAMPLES_ENABLED = process.env.NODE_ENV !== "production"
  || process.env.REACT_APP_ENABLE_PUBLIC_REPORT_EXAMPLES === "true";
const url = `${API_BASE_URL}/report-examples`;

async function read(path, signal) {
  const response = await fetch(`${url}${path}`, { cache: "no-store", credentials: "omit", signal });
  if (!response.ok) throw new Error("Report example unavailable");
  return response.json();
}

export const getReportExamples = (signal) => read("", signal);
export const getReportExample = (slug, signal) => read(`/${encodeURIComponent(slug)}`, signal);
export async function exportReportExample(slug, side) {
  const response = await fetch(`${url}/${encodeURIComponent(slug)}/export`, {
    method: "POST",
    credentials: "omit",
    cache: "no-store",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ side }),
  });
  await downloadReportResponse(response, `informe-${slug}-${side}.pptx`);
}
